export default __webpack_public_path__ + "static/hexagon_w.5621866985f42a1399090ebff52ab950.svg";